import Lib from '../../commons/lib';

export default class Service {
  static kultikUrl = window.location.origin + '/api/kultik/';

  static helyszinUrl = window.location.origin + '/api/helyszin/';

  static eloadasUrl = window.location.origin + '/api/eloadas/';

  static cegadatUrl = window.location.origin + '/api/cegadat/';

  static ugyfelszolgalatUrl = window.location.origin + '/api/ugyfelszolgalat/';

  // ELOADAS START

  static listEloadas(input, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.eloadasUrl + 'eloadas/list/base',
          args: { requestType: 'eloadas-list-base' },
          params: {
            param: input
          }
        }
      ],
      fnDone
    );
  }

  // ELOADAS END

  // TEVÉKENYSÉG START

  static listTevekenyseg(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'tevekenyseg/list',
          args: { requestType: 'tevekenyseg-list-get' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static getTevekenyseg(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'tevekenyseg',
          args: { requestType: 'tevekenyseg-list-list' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addTevekenyseg(tevekenysegAdd, id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.kultikUrl + 'tevekenyseg',
          args: { requestType: 'tevekenyseg-post' },
          data: tevekenysegAdd,
          params: { helyszinid: id }
        }
      ],
      fnDone
    );
  }

  static modifyTevekenyseg(tevekenysegModosit, id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.kultikUrl + 'tevekenyseg',
          args: { requestType: 'tevekenyseg-put' },
          data: tevekenysegModosit,
          params: { helyszinid: id }
        }
      ],
      fnDone
    );
  }

  static deleteTevekenyseg(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.kultikUrl + 'tevekenyseg',
          args: { requestType: 'tevekenyseg-delete' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static listTevekenysegEnums(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'tevekenyseg/enum',
          args: { requestType: 'tevekenyseg-enum-list' }
        }
      ],
      fnDone
    );
  }

  // TEVÉKENYSÉG END

  // IMAGE START

  static listEditorImages(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kultikUrl + 'editor/list',
      args: { requestType: 'editor-list-get' }
    }], fnDone);
  }

  static uploadEditorImage(file, id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kultikUrl + 'editor',
      args: { requestType: 'editor-post' },
      params: { funkcioId: id },
      data: file
    }], fnDone);
  }

  static deleteEditorImages(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.kultikUrl + 'editor',
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
        }
      ],
      fnDone
    );
  }

  static deleteEditorImage(id, imageName, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.kultikUrl + `editor/image/${imageName}`,
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
        }
      ],
      fnDone
    );
  }

  // IMAGE END

  // HELYSZÍN START

  static listHelyszinSelect(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'helyszin/list/select',
          args: { requestType: 'helyszin-list-select' },
          params: { tipus: 'SAJAT' }
        }
      ],
      fnDone
    );
  }

  static listHelyszinSelectOsszes(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'helyszin/list/select',
          args: { requestType: 'helyszin-list-select-all' },
          params: { tipus: 'OSSZES' }
        }
      ],
      fnDone
    );
  }

  static addHelyszin(helyszinObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.helyszinUrl + 'helyszin',
          args: { requestType: 'helyszin-post' },
          data: helyszinObj
        }
      ],
      fnDone
    );
  }

  static modifyHelyszin(helyszinObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.helyszinUrl + 'helyszin',
          args: { requestType: 'helyszin-put' },
          data: helyszinObj
        }
      ],
      fnDone
    );
  }

  static deleteHelyszin(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.helyszinUrl + 'helyszin',
          args: { requestType: 'helyszin-delete' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static getHelyszin(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'helyszin',
          args: { requestType: 'helyszin-get' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  // HELYSZÍN END

  // BÜFÉ LISTA START

  static listBufelista(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'bufelista/list',
          args: { requestType: 'bufelista-list-get' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addBufelista(obj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.kultikUrl + 'bufelista',
          args: { requestType: 'bufelista-post' },
          data: obj
        }
      ],
      fnDone
    );
  }

  static modifyBufelista(obj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.kultikUrl + 'bufelista',
          args: { requestType: 'bufelista-put' },
          data: obj
        }
      ],
      fnDone
    );
  }

  static deleteBufelista(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.kultikUrl + 'bufelista',
          args: { requestType: 'bufelista-delete' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static rendezBufelista(array, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.kultikUrl + 'bufelista/rendez',
          args: { requestType: 'bufelista-rendez-put' },
          data: array
        }
      ],
      fnDone
    );
  }

  static getBufelista(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'bufelista/getbufelista',
          args: { requestType: 'bufelista-getbufelista-get' },
          params: {
            id: id
          }
        }
      ],
      fnDone
    );
  }

  // BÜFÉ LISTA END

  // SLIDESHOW START

  static getSlideshow(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'slideshow',
          args: { requestType: 'slideshow-get' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static listSlideshow(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'slideshow/list',
          args: { requestType: 'slideshow-list-get' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addSlideshow(obj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.kultikUrl + 'slideshow',
          args: { requestType: 'slideshow-post' },
          data: obj
        }
      ],
      fnDone
    );
  }

  static modifySlideshow(obj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.kultikUrl + 'slideshow',
          args: { requestType: 'slideshow-put' },
          data: obj
        }
      ],
      fnDone
    );
  }

  static deleteSlideshow(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.kultikUrl + 'slideshow',
          args: { requestType: 'slideshow-delete' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static rendezSlideshow(array, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.kultikUrl + 'slideshow/rendez',
          args: { requestType: 'slideshow-rendez-put' },
          data: array
        }
      ],
      fnDone
    );
  }

  static listPosEnum(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'slideshow/enum',
          args: { requestType: 'kultik-enum-get' }
        }
      ],
      fnDone
    );
  }

  // SLIDESHOW END

  // PROMOCIOK START

  static listPromocio(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'promocio/list',
          args: { requestType: 'promocio-list-get' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addPromocio(promocioObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.kultikUrl + 'promocio',
          args: { requestType: 'promocio-post' },
          data: promocioObj
        }
      ],
      fnDone
    );
  }

  static editPromocio(promocioObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.kultikUrl + 'promocio',
          args: { requestType: 'promocio-put' },
          data: promocioObj,
          params: { id: promocioObj.id }
        }
      ],
      fnDone
    );
  }

  static getPromocio(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'promocio',
          args: { requestType: 'promocio-gets' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static deletePromocio(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.kultikUrl + 'promocio',
          args: { requestType: 'promocio-delete' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  // PROMOCIOK END

  // EXTRACONTENT START

  static listExtracontent(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'extracontent/list',
          args: { requestType: 'extracontent-list-get' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static listExtracontentTipus(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'extracontent/listtipus',
          args: { requestType: 'extracontent-listtipus-get' },
        }
      ],
      fnDone
    );
  }

  static addExtracontent(extracontentObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.kultikUrl + 'extracontent',
          args: { requestType: 'promocio-post' },
          data: extracontentObj
        }
      ],
      fnDone
    );
  }

  static editExtracontent(extracontentObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.kultikUrl + 'extracontent',
          args: { requestType: 'extracontent-put' },
          data: extracontentObj,
          params: { id: extracontentObj.id }
        }
      ],
      fnDone
    );
  }

  static getExtracontent(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'extracontent',
          args: { requestType: 'extracontent-gets' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static deleteExtracontent(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.kultikUrl + 'extracontent',
          args: { requestType: 'extracontent-delete' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static listExtracontentValtozo(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "GET",
          url: Service.kultikUrl + "extracontent/valtozo",
          args: { requestType: "extracontent-valtozo-get" },
        }
      ],
      fnDone
    );
  }
  
  // EXTRACONTENT END

  // CEGADAT START

  static searchCegadat(resultclass, aktiv, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.cegadatUrl + 'search',
      args: { requestType: 'cegadat-search' },
      params: {
        resultclass: resultclass,
        aktiv: aktiv
      }
    }], fnDone);
  }

  // CEGADAT END

  // UGYFELSZOLGALAT START

  static listEsetTipus(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.ugyfelszolgalatUrl + 'esettipus/listbypublic',
          args: { requestType: 'esettipus-list-get' },
          params: { publikus: 'true' }
        }
      ],
      fnDone
    );
  }

  // UGYFELSZOLGALAT END

  // PARAMETER START

  static getAngolNyelv(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kultikUrl + 'parameter/angolnyelv',
      args: { requestType: 'parameter-angolnyelv' },
    }], fnDone);
  }

  // PARAMETER END
}
